import Minze from 'minze'

export const renderPagination = (
  paginationWrapper: HTMLElement,
  currentPage: number,
  totalPages: number
) => {
  const paginationList = paginationWrapper
  if (!paginationList) return

  paginationList.innerHTML = '' // Clear previous content

  // Create First Page and Previous Button
  if (currentPage === 1) {
    const firstPage = createPageButton(currentPage, 1, 1, 'pagination__page', 'page')
    paginationList.appendChild(firstPage)
  }
  if (currentPage > 1) {
    const firstPage = createPageButton(currentPage, 1, 1, 'pagination__page', 'page')
    const prevPage = createPageButton(currentPage, currentPage - 1, '<', 'pagination__prev', 'prev')
    paginationList.appendChild(prevPage)
    paginationList.appendChild(firstPage)
  }

  // Calculate range of visible pages
  let startPage = Math.max(2, currentPage - 1) // Starting from the currentPage - 1
  let endPage = Math.min(totalPages - 1, currentPage + 1) // Ending at currentPage + 1

  if (currentPage === 1) endPage = Math.min(totalPages - 1, 3) // Show more pages when on the first
  if (currentPage === totalPages) startPage = Math.max(2, totalPages - 2) // Show more pages near the end

  // Handling ellipsis for long ranges
  if (startPage > 2) {
    paginationList.appendChild(createEllipsis())
  }

  // Add page numbers between the first and last page
  for (let i = startPage; i <= endPage; i++) {
    paginationList.appendChild(createPageButton(currentPage, i, i, 'pagination__page', 'page'))
  }
  // Ellipsis before last page
  if (endPage < totalPages - 1) {
    paginationList.appendChild(createEllipsis())
  }
  // Create Last Page and Next Button
  if (currentPage <= totalPages && totalPages > 1) {
    const lastPage = createPageButton(
      currentPage,
      totalPages,
      totalPages,
      'pagination__page',
      'page'
    )
    paginationList.appendChild(lastPage)

    if (currentPage < totalPages) {
      paginationList.appendChild(
        createPageButton(currentPage, currentPage + 1, '>', 'pagination__next', 'next')
      )
    }
  }
}
const createPageButton = (
  currentPage: number,
  page: number,
  text: string | number,
  classname: string,
  paginationEl: string
) => {
  const btn = document.createElement('button')
  btn.textContent = text + ''
  btn.classList.add(classname)
  btn.setAttribute('pagination-el', paginationEl)
  btn.dataset.page = page + ''
  if (page === currentPage) {
    btn.classList.add('is-active')
  }
  if (paginationEl === 'prev') {
    btn.innerHTML = paginationChevron
  } else if (paginationEl === 'next') {
    btn.innerHTML = paginationChevron
    btn.style.transform = 'rotate(180deg)'
  }
  // Add onClick listener to fire Minze event on pagination button click
  btn.addEventListener('click', e => {
    const target = e.target as HTMLElement
    if (!target) return
    const button = target.closest('button')
    if (!button) return
    if (!button.dataset.page) return
    const page = parseInt(button.dataset.page)

    // Emit event to parent component
    Minze.cast('lvc:search-pagination-event', {
      goToPage: page,
    })
  })
  return btn
}

const createEllipsis = () => {
  const ellipsis = document.createElement('span')
  ellipsis.textContent = '...'
  ellipsis.classList.add('ellipsis')
  return ellipsis
}

const paginationChevron = `
  <svg class="pagination__icon" width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8506 19.2761C11.56 19.7458 10.9437 19.891 10.474 19.6004C9.38311 18.9256 6.93854 16.8589 4.83204 14.9677C3.76294 14.0078 2.75061 13.0657 2.00134 12.3274C1.62857 11.96 1.30954 11.632 1.07875 11.3723C0.965335 11.2446 0.857324 11.1158 0.772111 10.9969C0.730413 10.9388 0.678974 10.8621 0.633845 10.775L0.632922 10.7732C0.604789 10.719 0.500106 10.5172 0.500106 10.25C0.500106 9.96485 0.620827 9.74996 0.648866 9.70005L0.651213 9.69586C0.699243 9.60976 0.753809 9.53304 0.798219 9.47431C0.889394 9.35376 1.00631 9.21968 1.13119 9.08387C1.38504 8.80781 1.73716 8.45425 2.14717 8.05606C2.97065 7.25633 4.07337 6.23253 5.19938 5.20035C6.12654 4.35045 7.06232 3.5012 7.87873 2.76027C9.07065 1.67856 10.0081 0.827745 10.293 0.542893C10.6835 0.152369 11.3167 0.152369 11.7072 0.542893C12.0977 0.933418 12.0977 1.56658 11.7072 1.95711C11.3907 2.27361 10.3715 3.19877 9.12188 4.33309C8.31828 5.06253 7.4194 5.87846 6.55083 6.67465C5.42684 7.70497 4.34206 8.71242 3.54054 9.49082C3.23236 9.7901 2.97268 10.0491 2.77144 10.259C2.94087 10.4388 3.15391 10.6553 3.40512 10.9028C4.1246 11.6118 5.11227 12.5315 6.16817 13.4795C8.31167 15.4039 10.6171 17.3372 11.5262 17.8996C11.9959 18.1901 12.1411 18.8064 11.8506 19.2761Z" fill="#1E007D"/>
  </svg>
`
